import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface CustomerListActionsHeaderProps
  extends HeaderContext<GatewayCustomerModel, unknown> {}

export const CustomerListActionsHeader =
  (): // props: CustomerListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
